var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key,staticClass:"component-label-custom",class:{'component-label-custom-disabled' : _vm.disabled},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.state ? "默认查询" : "高级查询")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }